<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <div class="search-wrapper">
        <Form
          label-position="right"
          :label-width="0"
          class="search-list-430 search-wrapper-430"
        >
          <Row type="flex" flex="end">
            <FormItem label="">
              <Input
                v-model.trim="searchConds.searchStr"
                class="search-input-430"
                placeholder="请输入教育局单位名称"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.orgKind"
                placeholder="请选择单位类别"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in orgKindList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="">
              <Cascader
                v-model="searchConds.area"
                placeholder="请选择所属行政区"
                clearable
                :data="regionDataList"
                @on-change="handelAreaChange"
              ></Cascader>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.coSts"
                placeholder="请选择合作状态"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in cooperationList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.infoSts"
                placeholder="请选择信息完善状态"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in completeStatusList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>

            <Button type="primary" @click="handleSearch">确定</Button>
            <Button class="search-430" @click="handleReset">重置</Button>
          </Row>
        </Form>
      </div>
      <div class="table-title-special-430"></div>
    </div>
    <div class="table">
      <Table
        ref="selection"
        border
        :columns="tableColumns"
        :data="tableData"
        :max-height="tableHeight"
        :loading="tableLoading"
      >
        <template slot="action" slot-scope="{ row }">
          <span
            class="ordinary-color-430"
            @click="handleToDetail(row)"
          >查看详情</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        show-total
        show-elevator
        :current="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        @on-change="handlePageChange"
      ></Page>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { regionDataList } from '@/utils/dictionary';
// import {addressOptions} from '@/util'
import operationAdmin from '@/request/operationAdmin/index.js';
import { opeEduListColumns } from '@/pages/assetsModules/manageData.js';
import { orgKindList, cooperationList, completeStatusList } from '@/utils/dictionary.js';
import EditButton from '@/pages/assetsModules/EditButton';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  name: 'CompanyEduMage',
  components: {
    EditButton
  },
  filters: {
    InitCooperateState(v) {
      switch (v) {
        case 1:
          return '正常';
        case 2:
          return '已停止合作';
      }
    }
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      regionDataList: [],
      pageInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      searchConds: {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        area: [],
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        coSts: null // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
      },
      // tableColumns: [...opeEduListColumns],
      orgKindList, // 单位类别列表
      cooperationList, // 合作状态列表
      completeStatusList, // 信息完善状态
      tableData: [],
      tableLoading: false
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['routeTitle']),
    tableColumns() {
      if (this.userInfo.userType === 5) {
        return [
          ...opeEduListColumns,
          {
            title: '创建账号',
            key: 'creatorName',
            minWidth: 180,
            align: 'center'
          }
        ];
      } else {
        return [...opeEduListColumns];
      }
    }
  },
  created() {
    this.regionDataList = [...regionDataList];
    this.getListBureau();
    // // 超管账号
    // if (this.userInfo.userType === 5) {
    //   this.tableColumns.push({
    //     title: '创建账号',
    //     key: 'creatorName',
    //     minWidth: 180,
    //     align: 'center'
    //   });
    // }
  },
  activated() {
    this.getListBureau();
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CompanyEduMage');
    next();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    // 地区选择
    handelAreaChange(value, selectedData) {
      this.searchConds.area = value;
      this.searchConds.areaCode = value[value.length - 1];
    },
    // 重置
    handleReset() {
      this.searchConds = {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        coSts: null // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
      };
      this.pageInfo.pageNum = 1;
      this.getListBureau();
    },
    // 查询
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getListBureau();
    },
    // 分页
    handlePageChange(v) {
      this.pageInfo.pageNum = v;
      this.getListBureau();
    },
    // 教育局详情
    handleToDetail(row, index) {
      this.$router.push({
        name: 'resource_educationdetail',
        query: { orgId: row.orgId }
      });
    },
    // 查询教育局列表
    async getListBureau() {
      const { total, ...pageInfo } = this.pageInfo;
      const { area, ...searchConds } = this.searchConds;
      const params = { ...pageInfo, ...searchConds };
      this.tableLoading = true;
      const res = await operationAdmin.getEduListNew(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      } else {
        this.$Message.error(res.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.page-container {
  height: 100%;
  box-sizing: border-box;
  .green {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: green;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
  .purple {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: purple;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
}
.col-center {
  padding: 0 8px;
  margin-bottom: 8px;
  button + button {
    margin-left: 16px;
  }
}
</style>
